// src/components/store/sections/faqs/FaqV78ClaytogglesOceanCyan.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV78ClaytogglesOceanCyan(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={78}
      archKey="clay_toggles"
      archLabel="3D Claymorphic Toggles"
      palName="OceanCyan"
      grad="from-cyan-500 via-sky-500 to-blue-700"
      lightBg="bg-cyan-50"
      textCol="text-cyan-700"
      borderCol="border-cyan-200"
      btnCls="bg-blue-600 hover:bg-blue-700"
      hexCol="#06b6d4"
      {...props}
    />
  );
}
